<form
  [formGroup]="form"
  class="card p-6!"
  *transloco="let t; prefix: 'wizard.project'"
  data-testid="generalinformation-form"
>
  <p-fluid>
    <div class="flex flex-col gap-4">
      <div class="flex flex-wrap gap-4">
        <div class="flex flex-col grow basis-0 gap-4">
          <div class="flex flex-col gap-4">
            <app-form-field
              id="name"
              fieldName="name"
              [label]="t('namePlaceholder')"
              [placeholder]="t('namePlaceholder')"
            />
          </div>
          <div class="flex flex-col grow basis-0 gap-4">
            <div class="flex flex-col gap-4">
              <app-form-field
                id="description"
                fieldName="description"
                type="textarea"
                [label]="t('description')"
                [placeholder]="t('descriptionPlaceholder')"
              />
            </div>
          </div>
          <div class="text-xl" data-testid="years-label">{{ t('yearsInScope') }}</div>
          <div class="flex flex-wrap gap-4" data-testid="years-options">
            @for (i of yearsInScopeOptions; track $index) {
              <div class="flex items-center" [attr.data-testid]="'years-' + i">
                <p-radiobutton
                  formControlName="yearsInScope"
                  name="yearsInScope"
                  [value]="i"
                  [inputId]="'year' + i"
                ></p-radiobutton>
                <label [for]="'year' + i" class="ml-2">
                  {{ i }}
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </p-fluid>
</form>
